// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__3qAFx","resendInfoText":"OnGoingPaymentBox_resendInfoText__18o3o"};